import React, {memo, useMemo} from 'react'
import cx from 'classnames'

/* Utils */
import DataSet from '../../../../utils/DataSet'

/* Styles */
import s from './green-band.scss'

const GreenBand = memo(({
  className,
  campaignEvaluateResult,
  sku,
  pageTypeForDavinci,
  productId,
  merchantName,
  merchantId,
  listingId,
  price,
  categoryId,
  categoryName,
  incentiveToBuy
}) => {
  const greenBandText = campaignEvaluateResult?.evaluateAsPremiumResult?.campaignText || campaignEvaluateResult?.evaluateResult?.campaignText

  if (!greenBandText) {
    return null
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const componentViewEventData = useMemo(() => ({
    pageValue: sku,
    pageType: pageTypeForDavinci,
    productId,
    merchantName,
    merchantId,
    listingId,
    price: `${price}`,
    categoryHierarchy: `${categoryId} - ${categoryName}`,
    tagName: incentiveToBuy?.tagName,
    imageLabel: incentiveToBuy?.text,
    type: incentiveToBuy?.type,
  }), [sku])

  return (
    <div
      className={cx(s.root, className)}
      data-hbus={DataSet.createComponentViewDataForDavinci({
        position: 1,
        placement: 'Greenband',
        component: 'Greenband',
        componentDetail: campaignEvaluateResult?.evaluateResult?.campaignText ,
        ...componentViewEventData
      })}>
      <i className={s.icon} />
      <span className={s.text}>{greenBandText}</span>
    </div>
  )
})

export default GreenBand
